export const RESERVED_ROUTES = new Set([
  "",
  "admin",
  "login",
  "register",
  "dashboard",
  "donate",
  "success",
  "cancel",
  "pricing",
  "features",
  "about",
  "contact",
  "settings",
  "onboarding",
  "checkout",
  "receipt",
  "privacy",
  "terms",
  "platform",
  "lightly",
  "auth",
  "auth/action",
  "action",
  "verify-email",
  "reset-password",
  "signup-org",
  "signup-participant",
  "become-a-fundraiser",
  "participant",
  "org-donate",
  "test",
  "test-search",
  "o",
]);

export function normalizeRouteSegment(value) {
  return String(value || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .split("/")[0]
    .toLowerCase();
}

export function isReservedRoute(value) {
  return RESERVED_ROUTES.has(normalizeRouteSegment(value));
}
